module.exports = __webpack_public_path__ + "img/9791195152100.f93b5b1c.jpg";